/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestMapleV2WithdrawalManager extends Contract<ITestMapleV2WithdrawalManager> {
  exitCycleId: Call<(_owner: AddressLike) => BigNumber, ITestMapleV2WithdrawalManager>
  'exitCycleId(address)': Call<(_owner: AddressLike) => BigNumber, ITestMapleV2WithdrawalManager>
  getCurrentConfig: Call<() => { initialCycleId: BigNumber, initialCycleTime: BigNumber, cycleDuration: BigNumber, windowDuration: BigNumber }, ITestMapleV2WithdrawalManager>
  'getCurrentConfig()': Call<() => { initialCycleId: BigNumber, initialCycleTime: BigNumber, cycleDuration: BigNumber, windowDuration: BigNumber }, ITestMapleV2WithdrawalManager>
  getWindowAtId: Call<(_cycleId: BigNumberish) => { windowStart_: BigNumber, windowEnd_: BigNumber }, ITestMapleV2WithdrawalManager>
  'getWindowAtId(uint256)': Call<(_cycleId: BigNumberish) => { windowStart_: BigNumber, windowEnd_: BigNumber }, ITestMapleV2WithdrawalManager>
  lockedShares: Call<(_account: AddressLike) => BigNumber, ITestMapleV2WithdrawalManager>
  'lockedShares(address)': Call<(_account: AddressLike) => BigNumber, ITestMapleV2WithdrawalManager>
}

let ITestMapleV2WithdrawalManagerBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestMapleV2WithdrawalManagerBytecode = '0x';
}

// prettier-ignore
export const ITestMapleV2WithdrawalManager = contract<ITestMapleV2WithdrawalManager>(ITestMapleV2WithdrawalManagerBytecode)`
  function exitCycleId(address _owner) view returns (uint256 exitCycleId_)
  function getCurrentConfig() view returns (tuple(uint64 initialCycleId, uint64 initialCycleTime, uint64 cycleDuration, uint64 windowDuration) config_)
  function getWindowAtId(uint256 _cycleId) view returns (uint256 windowStart_, uint256 windowEnd_)
  function lockedShares(address _account) view returns (uint256 lockedShares_)
`;